module.exports = __webpack_public_path__ + "img/logo_06.b8cb49ee.png";